<template>
    <div class="list-container">
        <div class="list-bread-crumb-div">
            <ZD-bread-crumb :bConfigList="pageConfig.relationBreadCrunm"></ZD-bread-crumb>
        </div>
        <div class="list-content-div">
            <div class="list-header-title-div">关联账号详情</div>
            <ZD-list-querys>
                <template slot="inputs">
                    <div class="list-query-child-div flex">
                        <div class="query-title-div">用户手机号</div>
                        <div class="query-inputs-div flex-1">
                            <el-input size="small" v-model="queryInfo.custPhone" placeholder="请输入内容" clearable
                                      @keyup.enter.native="getFormInfo(pagination, true)"></el-input>
                        </div>
                    </div>
                    <div class="list-query-child-div flex">
                        <div class="query-title-div">充电桩编号</div>
                        <div class="query-inputs-div flex-1">
                            <el-input size="small" v-model="queryInfo.pileCode" placeholder="请输入内容" clearable disabled
                                    @keyup.enter.native="getFormInfo(pagination, true)"></el-input>
                        </div>
                    </div>
                </template>
                <template slot="actions">
                    <div class="">
                        <button class="common-bg-button" @click="getFormInfo(pagination, true)">搜 索</button>
                        <button class="common-empty-button" @click="reset()">重 置</button>
                    </div>
                </template>
            </ZD-list-querys>
            <!-- 表格 -->
            <div class="list-table">
                <ZD-table :tableColumns="pageConfig.relationColumns" :operates="operates"
                        :tableData="tableData" :tableConfig="pageConfig.tableConfig" :selections="selections"
                        v-on:updateSelections="(sels) => { selections = sels }"></ZD-table>
            </div>
            <!-- 分页 -->
            <div class="list-pagination">
                <ZD-pagination :pagination="pagination" v-on:pageUpdate="getFormInfo"></ZD-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import utils from '../../../utils/utils'
    import config from '../../../config/config'
    import pageConfig from './page-config'
    import axios from 'axios'
    export default {
        data() {
            return {
                pageConfig,
                pagination: pageConfig.pagination,
                queryInfo: {
                    custPhone: '',
                    pileCode: this.$store.state.editId,
                },
                operates: {
                    width: 220,
                    fixed: 'right',
                    list: [
                        {
                            id: 'charge',
                            label: '充电记录',
                            type: 'primary',
                            show: true,
                            disabled: false,
                            method: (index, row) => {
                                this.$store.commit('setEditId', row.pileCode)
                                // this.$router.push({
                                // 	name: pageConfig.chargeDetailRouter
                                // });
                                window.open(
                                    this.$router.resolve({ name: pageConfig.chargeDetailRouter })
                                        .href,
                                    '_blank'
                                )
                            },
                        },
                    ],
                }, // 列操作按钮
                tableData: [], // 表格数据
                selections: [], // 表格选项
            }
        },
        methods: {
            init() {
                let _= this;
                _.getFormInfo(_.pagination)
            },
            // 获取表单信息
            getFormInfo(pagination, reload = false) {
                let _ = this
                _.$U.showLoading(_)
                _.queryInfo.pageNum = pagination.current - 1
                if (reload) {
                    _.queryInfo.pageNum = 0
                }
                _.queryInfo.pageSize = pagination.pageSize
                _.$H.post(_, _.$A.digitization.pileCust, _.queryInfo).then(res => {
                    _.tableData = res.data.data.content
                    _.$U.hideLoading(_)
                })
            },
            //选择表格
            checkSelectOne() {
                if (this.selections.length < 1) {
                    this.$U.error('请选择需要操作的对象')
                    return false
                }
                if (this.selections.length > 1) {
                    this.$U.error('只能选择一个操作的对象')
                    return false
                }
                return true
            },
            reset(){
                let _ = this;
                _.queryInfo = {
                    custPhone: '',
                    pileCode: _.$store.state.editId
                }
                _.getFormInfo(_.pagination)
            }
        },
        mounted() {
            this.init()
        },
    }
</script>

<style lang="less" scoped>
    .query-title-div {
        width: 90px !important;
    }
    .lang-width {
        width: 450px !important;
    }
    .list-content-div {
        margin-top: 16px;
    }
</style>
